"use client";

import { DocPreviewPanel } from "@/components/doc-preview-panel";
import { useState } from "react";

// Resizable right-hand wrapper around the shared DocPreviewPanel — the same
// drag-handle recipe used by chat-view and the workflow session page, for
// page-level file previews (project file lists).
export function ProjectFilePreviewPanel({
  filename,
  url,
  onClose,
}: {
  filename: string;
  url: string;
  onClose: () => void;
}) {
  const [width, setWidth] = useState(() =>
    typeof window !== "undefined" ? Math.round(window.innerWidth * 0.35) : 420
  );

  return (
    <>
      {/* Drag handle */}
      <div
        className="group relative z-10 w-px shrink-0 cursor-col-resize select-none"
        onMouseDown={(e) => {
          e.preventDefault();
          const startX = e.clientX;
          const startWidth = width;

          const overlay = document.createElement("div");
          overlay.style.cssText = "position:fixed;inset:0;z-index:9999;cursor:col-resize;";
          document.body.appendChild(overlay);

          const onMove = (mv: MouseEvent) => {
            const delta = startX - mv.clientX;
            setWidth(Math.max(288, Math.min(window.innerWidth * 0.75, startWidth + delta)));
          };
          const onUp = () => {
            overlay.remove();
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseup", onUp);
          };
          window.addEventListener("mousemove", onMove);
          window.addEventListener("mouseup", onUp);
        }}
      >
        <div className="absolute inset-y-0 -left-2 -right-2" />
      </div>
      <DocPreviewPanel filename={filename} url={url} width={width} onClose={onClose} />
    </>
  );
}
